import React, { Suspense } from "react";
import {
  adminRoutesProtected,
  adminRoutesPublic,
  protectedRoutes,
  publicRoutes,
  themeRoutes,
} from "./allRoutes";
import { Routes, Route } from "react-router-dom";
import { AuthProtected } from "./AuthProtected";
import NonAuthLayout from "../Layout/NonAuthLayout";
import { AdminAuthProtected } from "./AdminAuthProtected";
import Loader from "../Component/Loader";

const Index = () => {
  console.log("running");
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* Public Routes */}
        <Route element={<NonAuthLayout />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={<route.component />} key={idx} />
          ))}
        </Route>

        {/* Protected Routes */}
        <Route element={<AuthProtected />}>
          {protectedRoutes.map((route, idx) => (
            <Route path={route.path} element={<route.component />} key={idx} />
          ))}
        </Route>

        {/* Admin Routes */}
        <Route>
          {adminRoutesPublic.map((route, idx) => (
            <Route path={route.path} element={<route.component />} key={idx} />
          ))}
        </Route>
        <Route element={<AdminAuthProtected />}>
          {adminRoutesProtected.map((route, idx) => (
            <Route path={route.path} element={<route.component />} key={idx} />
          ))}
        </Route>
        {/* Theme Routes */}
        <Route>
          {themeRoutes.map((route, idx) => (
            <Route path={route.path} element={<route.component />} key={idx} />
          ))}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default Index;
